<template>
  <section class="seat-sidebar">
    <h2>{{ $t('travelPlanner.seat.seatDescription') }}</h2>
    <ul>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle selected">
          <svg>
            <use :xlink:href="`#${checked}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.selectedSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle"></div>
        {{ $t('travelPlanner.seat.seatTypes.vacantSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle occupied">
          <svg>
            <use :xlink:href="`#${cancel}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.seatTypes.unavailableSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle standard-seat">
          <svg>
            <use :xlink:href="`#${standardSeat}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.seatTypes.standardSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle standard-seat">
          <svg>
            <use :xlink:href="`#${comfortSeat}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.seatTypes.comfortSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle standard-seat">
          <svg>
            <use :xlink:href="`#${panoramaSeat}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.seatTypes.panoramaSeat') }}
      </li>
      <li class="seat-sidebar__descriptions">
        <div class="seat-sidebar__circle standard-seat">
          <svg>
            <use :xlink:href="`#${childSeat}`" />
          </svg>
        </div>
        {{ $t('travelPlanner.seat.seatTypes.childSeat') }}
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import type { Journey } from '@/types/journeyTypes'
  import seatIcon from '@/assets/icons/seat.svg'
  import checked from '@/assets/icons/checked.svg'
  import cancel from '@/assets/icons/cancel.svg'
  import standardSeat from '@/assets/icons/standardSeat.svg'
  import comfortSeat from '@/assets/icons/comfortSeat.svg'
  import panoramaSeat from '@/assets/icons/panoramaSeat.svg'
  import childSeat from '@/assets/icons/childSeat.svg'

  export default defineComponent({
    name: 'SeatSidebar',
    props: {
      journey: {
        type: Object as PropType<Journey | null>,
        required: false,
        default: null,
      },
    },
    setup() {
      return {
        seatIcon,
        checked,
        cancel,
        standardSeat,
        comfortSeat,
        panoramaSeat,
        childSeat,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .seat-sidebar {
    background-color: $clr-white;
    color: $clr-primary-800;
    padding: 20px;
    border-radius: $border-radius;
    box-shadow: $box-shadow-card;
    text-align: left;

    ul {
      list-style: none;
      padding: 0;
    }

    h2 {
      @include title-medium;
    }

    &__list_node {
      @include body-large;
      border: 1px solid $clr-primary-100;
      display: flex;
      padding: 1rem;
      margin-bottom: 1rem;
      border-radius: $border-radius;
      justify-content: space-between;
      align-content: center;
      align-items: center;
    }

    &__seat {
      svg {
        width: 16px;
        height: 20px;
        margin-right: 1rem;
      }
    }

    &__descriptions {
      border-bottom: 1px solid $clr-primary-50;
      display: flex;
      align-items: center;
      padding: 1rem;
    }
    &__circle {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: $clr-primary-100;
      border: 1px solid $clr-primary-300;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;

      &.selected {
        border: 1px solid $clr-secondary-800;
        background-color: $clr-secondary;
        color: $clr-white;
        svg {
          width: 14.15px;
          height: 11.5px;
        }
      }

      &.occupied {
        background-color: $clr-primary-50;
        border: 1px solid $clr-primary-300;
        color: $clr-primary-300;
        svg {
          width: 8.13px;
          height: 8.13px;
        }
      }

      &.standard-seat {
        width: 26px;
        height: 26px;
        background-color: transparent;
        border: none;
        color: $clr-primary-300;
        svg {
          width: 26px;
          height: 26px;
        }
      }
    }
  }
</style>
